import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { iRenuncia } from '../custodia/custodia';
import { NgForm } from '@angular/forms/src/directives/ng_form';
import * as moment from 'moment';
import { Proxy } from '../../services/proxy/proxy.service';

@IonicPage()
@Component({
  selector: 'page-modal-recibi',
  templateUrl: 'modal-recibi.html',
})
export class ModalRecibiPage {

  // #region Propiedades del controlador
  public custodia:Proxy.PrActasCustodia;
  public estados:Array<iRenuncia> = [
    {
      texto: 'Sin incidencias',
      valor:true
    },
    {
      texto: 'Con incidencias',
      valor: false
    }
  ];
  // #endregion

  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public viewCtrl:ViewController
    ) {
  }

  ionViewDidLoad() {
    this.custodia = <Proxy.PrActasCustodia>this.navParams.get("custodia");
    this.custodia.sinIncidencias = undefined;
  }

  // #region Métodos del controlador

  public ActualizarEstado(estado:iRenuncia):void{
    if (estado != undefined){
      this.custodia.sinIncidencias = estado.valor;
    }
  }

  public Guardar(form:NgForm):void{
    if (form.valid){
      this.custodia.recogida = true;
      this.custodia.fechaDevolucion = moment().toDate();
      this.viewCtrl.dismiss(this.custodia);
    }
  }

  // #endregion
}



// WEBPACK FOOTER //
// ./src/pages/modal-recibi/modal-recibi.ts